module.exports = __webpack_public_path__ + "img/orange_silhouette.dd81c165.png";